import React from 'react';
import {CompleteDetailsUIProvider} from '../components/CompleteDetailsUIContext';
import {CompleteDetailsCard} from './CompleteDetailsCard';

export function CompleteDetailsPage() {
  return (
    <CompleteDetailsUIProvider>
      <CompleteDetailsCard/>
    </CompleteDetailsUIProvider>
  );
}
